// @Version: 1.0.2
export interface IConfig {
   application: string,
   first: string,
   extern: boolean,
   released: string,
   others: string[],
   mode: number,
   dev: string,
   [key: string]: IProjectConfig | string | string[] | boolean | number
}

export interface IProjectConfig {
   name: string,
   productname: string,
   releasename: string,
   path: string,
   folder: string,
   href: string,
   csvname: string
}

export interface IVersion {
   design: string,
   release: string,
   [key: string]: IVersionData | string
}

export interface IVersionData {
   [key: string]: string
}

export enum DESIGNFILE {
   CONFIG = 'config',
   TEXTDEFAULT = 'de',
   TEXT = 'text'

}

export interface ResponseVersion {
   version: string;
}

export interface ResponseDesignVersion {
   version: string;
}

export interface ResponseAffected {
   affected?: number;
}

export enum ERROR {
   START = 0,
   UUID,
   BACKEND,
   GDIX,
   PROJECT,
   CONNECT,
   SGINALR,
   IGNORE,
   DPSAPI,
   LOGIN,
   INIT
}

export interface KeyValue {
   key: string;
   value: string;
}
export interface ResponseDesignTypography extends KeyValue{};
export interface ResponseTranslateText extends KeyValue{};
export interface ResponseTranslateConfig extends KeyValue{};
export interface ResponseDesignColor extends KeyValue{};

export interface IIdentifierDesign {
   projectname: string;
   version: string;
   option: string;
}